export const LabelStandardTrial = () => {
  return (
    <label
      className="nj-label-free nj-label-standard"
      data-e2e="label-tier-standard-trial"
    >
      Standard Trial
    </label>
  );
};
